import { Stack, Text } from '@mantine/core'

import { formatNumberWithCheckDigit } from '@/lib/utils'

interface Props {
  holder?: string
  agencyNumber?: string | number
  agencyCheckNumber?: string | number
  accountNumber?: string | number
  accountCheckNumber?: string | number
  taxDocument?: string
  bankName?: string
  bankCode?: string | number
  transferMethod?: string
  pixKey?: string
}

export default function BankAccount({
  holder,
  agencyNumber,
  agencyCheckNumber,
  accountNumber,
  accountCheckNumber,
  taxDocument,
  bankName,
  bankCode,
  transferMethod,
  pixKey
}: Props) {
  const isPix = transferMethod === 'pix'
  const shouldShowBankAccountData = transferMethod !== 'pix'
  const title = isPix
    ? 'Reembolso via Pix'
    : bankName && bankCode
      ? `Banco (Cód. ${bankCode}) ${bankName}`
      : 'Conta bancária'
  const formattedAgencyNumber = formatNumberWithCheckDigit(agencyNumber, agencyCheckNumber)
  const formattedAccountNumber = formatNumberWithCheckDigit(accountNumber, accountCheckNumber)

  return (
    <Stack spacing={0}>
      <Text>{title}</Text>
      {isPix && pixKey && (
        <Text size="sm" color="dimmed">
          Chave Pix: {pixKey}
        </Text>
      )}
      {shouldShowBankAccountData && formattedAgencyNumber && (
        <Text size="sm" color="dimmed">
          Agência: {formattedAgencyNumber}
        </Text>
      )}
      {shouldShowBankAccountData && formattedAccountNumber && (
        <Text size="sm" color="dimmed">
          Conta Corrente: {formattedAccountNumber}
        </Text>
      )}
      {holder && (
        <Text size="sm" color="dimmed">
          {holder}
        </Text>
      )}
      {taxDocument && (
        <Text size="sm" color="dimmed">
          Documento: {taxDocument}
        </Text>
      )}
    </Stack>
  )
}
